import BaseController from './base';

export default class ControllerDropdown extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });

    this._initialButtonTypes = {
      EBT_SELECTOR_BUTTON: 'selector_button',
    };

    this._initialButtonActions = {
      [this._initialButtonTypes.EBT_SELECTOR_BUTTON]: this.toggleDropdown.bind(this),
    };

    this._initialElementTypes = {
      EET_CONTAINER: 'container',
      EET_SELECTOR_BUTTON: this._initialButtonTypes.EBT_SELECTOR_BUTTON,
      EET_SELECTOR_LABEL: 'selector_label',
      EET_OPTIONS_LIST: 'options_list',
    };

    this._eButtonsTypes = {
      ...this._initialButtonTypes,
    };
    this._eButtonsActions = {
      ...this._initialButtonActions,
    };
    this._eElementsTypes = {
      ...this._initialElementTypes,
    };

    this._eEventTypes = {
      OPTION_CLICK: this.getEventName('option'),
      DROPDOWN_TOGGLE: `${this.controllerType}__dropdown_toggle`,
    };

    this._options = [];
    this._activeOption = null;

    this.init(container);
  }

  toggleDropdown(visible) {
    const element = this.interactiveElements[this._eElementsTypes.EET_CONTAINER];
    const className = 'common-ui__dropdown__visible';
    const hadClassName = element.classList.contains(className);

    if (visible === true) {
      element.classList.add(className);
    } else if (visible === false) {
      element.classList.remove(className);
    } else {
      element.classList.toggle(className);
    }

    const hasClassName = element.classList.contains(className);
    const isToggled = hadClassName !== hasClassName;

    if (isToggled) {
      this.emit(this._eEventTypes.DROPDOWN_TOGGLE, element.classList.contains(className));
    }
  }

  cleanup() {
    super.cleanup();
    this.toggleDropdown(false);
  }

  onOptionClick({ value }) {
    this.activeOption = value;
    this.emit(this._eEventTypes.OPTION_CLICK, value);
    this.toggleDropdown(false);
  }

  _updateOptions() {
    this.removeActions();

    const options = this._options.filter(el => el.value !== this._activeOption);
    const activeOption = this._options.find(el => el.value === this._activeOption);

    const optionButtons = options.reduce((acc, option, index) => {
      acc[`EBT_${index}`] = `option_${index}`;
      return acc;
    }, {});

    this._eButtonsTypes = { ...this._initialButtonTypes, ...optionButtons };
    this._eElementsTypes = { ...this._initialElementTypes, ...options.reduce((acc, option, index) => {
        acc[`EET_${index}`] = this._eButtonsTypes[`EBT_${index}`];
        return acc;
      }, {}) };
    this._eButtonsActions = { ...this._initialButtonActions, ...options.reduce((acc, option, index) => {
        acc[`option_${index}`] = this.onOptionClick.bind(this, option);
        return acc;
      }, {}) };

    this._interactiveElementsIds = null;
    let markup = '';

    for (let i = 0; i < options.length; i++) {
      const { label } = options[i];
      markup += `<button id=${this.interactiveElementsIds[this._eElementsTypes[`EET_${i}`]]} class="common-ui__dropdown__option">
                   <span>${label}</span>
                 </button>`;
    }
    this.setInnerHTML(this._eElementsTypes.EET_OPTIONS_LIST, markup);
    this._saveInteractiveElements();
    this.addActions();

    if (activeOption) {
      this.set(this._eElementsTypes.EET_SELECTOR_LABEL, activeOption.label);
    }
  }

  set activeOption(value) {
    this._activeOption = value;
    this._updateOptions();
  }

  set options(options) {
    this._options = options;
    this._updateOptions();
  }

  _getMarkup() {
    return `<div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER]} class="common-ui__dropdown">
      <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_SELECTOR_BUTTON]} class="common-ui__dropdown__head">
        <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_SELECTOR_LABEL]}>
        </span>
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25 20L35 30L25 40" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      
      <div class="common-ui__dropdown__body">
        <div class="common-ui__dropdown__body__options">
          <div class="common-ui__dropdown__body__options_wrapper">
            <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_OPTIONS_LIST]} class="common-ui__dropdown__body__options_wrapper_list">
            </div>
          </div>
        </div>
      </div>
    </div>`
  }
}
